import { render } from "./DocumentListCard.vue?vue&type=template&id=4350351a&scoped=true"
import script from "./DocumentListCard.vue?vue&type=script&lang=js"
export * from "./DocumentListCard.vue?vue&type=script&lang=js"

import "./DocumentListCard.vue?vue&type=style&index=0&id=4350351a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4350351a"]])

export default __exports__